import React from 'react';
import { isBlank } from 'utils/helperMethods';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useApp from 'reducers/hooks/useApp';
import useQuiz from 'reducers/hooks/useQuiz';
import useMyBundle from 'reducers/hooks/useMyBundle';
import useMortgageSurvey from 'reducers/hooks/useMortgageSurvey';
import Seo from 'sharedComponents/Seo';

import { Box } from '@material-ui/core';
import Loader from 'sharedComponents/Loader';
import Quiz from 'sharedComponents/Quiz';
import { appRoutes } from 'routes';
import { calculateQuizValues } from 'utils/quizHelper';

import SummaryPage from './components/SummaryPage';
import BuyerRegistration from './components/BuyerRegistration';

import useStyles from './useStyles';

const QuizPage = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const {
    quizValues,
    discardQuiz,
    setFinishQuiz,
    setRegistrationModalOpen,
    quizFinished,
    registrationModalOpen,
  } = useQuiz();

  const { setInitialSurveyValues, setManuallyChangedSurveyValues } = useMortgageSurvey();
  const { updateMyBundle, loading } = useMyBundle();

  const { currentUser, loadCurrentUser } = useApp();
  const isSignIn = !isBlank(currentUser);

  const handleFinish = () => {
    setFinishQuiz(true);
  };
  const handleBack = () => {
    setFinishQuiz(false);
  };

  const handleStartOver = () => {
    discardQuiz();
    setFinishQuiz(false);
  };

  const calculatedValuesToBidRequestAttributes = () => {
    const { incomeValue, houseValue, houseValueDp, totalDebtPayments } = calculateQuizValues(quizValues);

    return {
      priceTarget: houseValue,
      downPaymentTarget: houseValueDp,
      incomeAnnualPreTax: incomeValue,
      monthlyDebt: totalDebtPayments,
    };
  };

  const handleSaveMyBundle = async () => {
    const {
      houseValue: defaultTargetHomePrice,
      houseValueDp: defaultDownPayment,
      mortgagePaymentFinal: defaultMonthlyBudget,
    } = calculateQuizValues(quizValues);

    await updateMyBundle({ defaultMonthlyBudget, defaultDownPayment, defaultTargetHomePrice });
    discardQuiz();
    history.push(appRoutes.rootPath());
  };

  const handleRegistrationFinish = async () => {
    loadCurrentUser();
    handleSaveMyBundle();
  };

  const handleSave = () => {
    if (isSignIn) {
      handleSaveMyBundle();
      return;
    }

    setRegistrationModalOpen(true);
  };

  const handleSignUpModalClose = () => setRegistrationModalOpen(false);

  const handleCompare = () => {
    const initialValues = calculatedValuesToBidRequestAttributes();
    setManuallyChangedSurveyValues(true);
    setInitialSurveyValues(initialValues);
    history.push(appRoutes.surveyPath());
  };

  if (loading) {
    return (
      <Box height="100%" display="flex" justifyContent="center" alignItems="center">
        <Loader />
      </Box>
    );
  }

  if (quizFinished) {
    return (
      <Box width="100%" height="100%">
        <Seo title={t('meta.QuizPage.title')} description={t('meta.QuizPage.description')} />
        <SummaryPage
          quizValues={quizValues}
          onBack={handleBack}
          onStartOver={handleStartOver}
          onSave={handleSave}
          onCompare={handleCompare}
        />
        {registrationModalOpen && (
          <BuyerRegistration onClose={handleSignUpModalClose} onFinish={handleRegistrationFinish} />
        )}
      </Box>
    );
  }

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
      <Seo title={t('meta.QuizPage.title')} description={t('meta.QuizPage.description')} />
      <Box className={classes.paper}>
        <Quiz onFinish={handleFinish} />
      </Box>
    </Box>
  );
};

export default QuizPage;



// WEBPACK FOOTER //
// ./src/components/QuizPage/QuizPage.js